import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8607b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-wrapper w-full" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "already-in-room" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mr-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "ml-1 text-green-500" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-sm font-medium mt-3 text-black" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base mb-3" }, "No Camera Detected", -1))
const _hoisted_11 = { class: "text-sm font-medium mt-3 text-black" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base mb-3" }, "No Microphone Detected", -1))
const _hoisted_13 = { class: "text-sm font-medium mt-3 text-black" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base" }, "No Audio Output Detected", -1))
const _hoisted_15 = { class: "text-sm font-medium mt-3 text-black" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base" }, "System Default Audio Output", -1))
const _hoisted_17 = {
  key: 0,
  class: "flex my-2 p-6 h-fit bg-white rounded-lg border border-gray-200 shadow-md text-sm"
}
const _hoisted_18 = { class: "grid w-full" }
const _hoisted_19 = ["disabled"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import PreviewTwilio from '@/components/checkup/PreviewTwilio.vue'
import PreviewVideo from '@/components/checkup/PreviewVideo.vue'
import PreviewZoom from '@/components/checkup/PreviewZoom.vue'
import useTestPage from '@/composables/useTestPage'
import { Engine } from '@/types/enums/room.enum'
import { useDeviceStore } from '@/stores'
import { setAudioInput, setAudioOutput, setVideoInput } from '@/services/device-state'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewBeforeJoin',
  props: {
  canJoinRoom: {
    type: Boolean,
    default: false,
  },
},
  emits: ['join-room', 'test-room'],
  setup(__props, { emit: __emit }) {


const emit = __emit

const isOpenPopup = ref(false)
// Store
const device = useDeviceStore()

// Hook
const { initLoading, engine, localParticipantInfo, alreadyParticipants, roomTitle, onInit } =
  useTestPage()

/**
 * Computed
 */
const isShowPreview = computed(
  () =>
    !localParticipantInfo?.value?.isInvisible &&
    ![Engine.WHEREBY, Engine.VICOLLO].includes(engine.value),
)
const testRoomLink = computed(() => {
  switch (engine.value) {
    case Engine.TWILIO:
      return '/video-diagnostic'

    case Engine.ZOOM:
      return '/zoom-diagnostic'
    default:
      return ''
  }
})

const openAlertDevice = () => {
  isOpenPopup.value = true
}

const changeCamera = (deviceId: string) => {
  device.maskSelectedVideo = deviceId
  setVideoInput(deviceId)
}
const changeMicrophone = (deviceId: string) => {
  device.maskSelectedAudio = deviceId
  setAudioInput(deviceId)
}
const changeSpeaker = (deviceId: string) => {
  device.maskSelectedSpeaker = deviceId
  setAudioOutput(deviceId)
}

watch(
  () => [device.permissionError, device.someDeviceIsGone],
  () => {
    if (!isShowPreview.value) return
    if (device.permissionError || device.someDeviceIsGone) {
      openAlertDevice()
    }
  },
  { deep: true },
)

onMounted(async () => {
  await onInit()
  device.setEngine(engine.value)
  if (isShowPreview.value) {
    device.initialize()
    if (engine.value === Engine.TWILIO) {
      device.clearLocalTracks()
    }
  }
})

onBeforeUnmount(() => device.unsubscribeDeviceChange())

return (_ctx: any,_cache: any) => {
  const _component_LoadingProcess = _resolveComponent("LoadingProcess")!
  const _component_AvatarStack = _resolveComponent("AvatarStack")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createBlock(_component_DefaultLayout, {
    "have-navbar": "",
    theme: "light",
    "can-change-language": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoadingProcess, {
        loading: !_unref(localParticipantInfo)?.isInvisible && !_unref(device).isReady && isShowPreview.value,
        message: `${_ctx.$t('waiting-for-permission')}`,
        class: "loading-ready"
      }, null, 8, ["loading", "message"]),
      (_unref(initLoading) && _unref(localParticipantInfo))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["test-device-page", isShowPreview.value ? '' : 'observer'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["left", isShowPreview.value ? '' : 'observer__padding'])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h1", {
                  class: _normalizeClass(["text-base lg:text-2xl xl:text-3xl font-bold color-orange", isShowPreview.value ? '' : 'text-center'])
                }, _toDisplayString(_unref(roomTitle)), 3),
                (!_unref(localParticipantInfo).isInvisible && _unref(device).isReady && isShowPreview.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(engine) === _unref(Engine).TWILIO)
                        ? (_openBlock(), _createBlock(PreviewTwilio, {
                            key: 0,
                            "can-set-background": true,
                            "is-auto-state": true
                          }))
                        : (_unref(engine) === _unref(Engine).ZOOM)
                          ? (_openBlock(), _createBlock(PreviewZoom, {
                              key: 1,
                              "is-auto-state": true,
                              "can-set-background": false,
                              "mirror-canvas": true
                            }))
                          : (_openBlock(), _createBlock(PreviewVideo, { key: 2 }))
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_AvatarStack, {
                  avatars: _unref(alreadyParticipants),
                  limit: 10,
                  "has-dot": "",
                  "show-avatar-list": "",
                  class: "flex flex-col items-center"
                }, {
                  "avatar-list": _withCtx(({ avatarListLabel, nMoreAvatar }) => [
                    (_unref(alreadyParticipants).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(avatarListLabel), 1),
                          nMoreAvatar
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('more-avatar.and')) + " " + _toDisplayString(nMoreAvatar) + " " + _toDisplayString(_ctx.$t('more-avatar.more')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(alreadyParticipants).length > 1 ? _ctx.$t('are-in-room') : _ctx.$t('is-in-room')), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('nobody-in-room')), 1))
                  ]),
                  _: 1
                }, 8, ["avatars"])
              ]),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["w-full", isShowPreview.value ? '' : 'hidden'])
              }, [
                (_unref(device).videoInputDevices.length)
                  ? (_openBlock(), _createBlock(_component_SelectOption, {
                      key: 0,
                      modelValue: _unref(device).selectedVideo,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_unref(device).selectedVideo) = $event)),
                        changeCamera
                      ],
                      label: _ctx.$t('camera'),
                      options: _unref(device).videoInputDevices,
                      class: "w-full"
                    }, null, 8, ["modelValue", "label", "options"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('camera')), 1),
                      _hoisted_10
                    ], 64)),
                (_unref(device).audioInputDevices.length)
                  ? (_openBlock(), _createBlock(_component_SelectOption, {
                      key: 2,
                      modelValue: _unref(device).selectedAudio,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_unref(device).selectedAudio) = $event)),
                        changeMicrophone
                      ],
                      label: _ctx.$t('microphone'),
                      options: _unref(device).audioInputDevices,
                      class: "w-full"
                    }, null, 8, ["modelValue", "label", "options"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('microphone')), 1),
                      _hoisted_12
                    ], 64)),
                (_unref(device).canSetSpeaker && _unref(device).audioOutputDevices.length)
                  ? (_openBlock(), _createBlock(_component_SelectOption, {
                      key: 4,
                      modelValue: _unref(device).selectedSpeaker,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((_unref(device).selectedSpeaker) = $event)),
                        changeSpeaker
                      ],
                      label: _ctx.$t('speaker'),
                      options: _unref(device).audioOutputDevices,
                      class: "w-full"
                    }, null, 8, ["modelValue", "label", "options"]))
                  : (_unref(device).canSetSpeaker && !_unref(device).audioOutputDevices.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('speaker')), 1),
                        _hoisted_14
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('speaker')), 1),
                        _hoisted_16
                      ], 64))
              ], 2), [
                [_vShow, _unref(device).isReady]
              ]),
              (_unref(localParticipantInfo).isInvisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_SvgIcon, {
                      class: "icon-container mr-2",
                      icon: "info",
                      "inherit-fill": true,
                      height: "16"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('observer')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: _normalizeClass(["join-btn mt-6 py-2 px-4 h-12", {
              'join-btn--warning':
                !_unref(localParticipantInfo).isInvisible &&
                (!_unref(device).videoInputDevices.length || !_unref(device).audioInputDevices.length),
            }]),
                  type: "button",
                  disabled: !__props.canJoinRoom,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('join-room')))
                }, [
                  _createVNode(_component_Loading, {
                    type: "dot",
                    class: "mr-2",
                    "is-loading": !__props.canJoinRoom
                  }, null, 8, ["is-loading"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('join-room')), 1)
                ], 10, _hoisted_19),
                (testRoomLink.value)
                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 0,
                      to: testRoomLink.value,
                      class: "mt-6 m-auto link-test-device"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('test-room')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "mt-6 m-auto link-test-device",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('test-room')))
                    }, _toDisplayString(_ctx.$t('test-room')), 1))
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})